import React, { Component } from "react";
import EditBand from "./editband";

class MainPage extends Component {
  render() {
    const { doLoad } = this.props;

    return (
      <React.Fragment>
        <EditBand moveToLogin={this.props.moveToLogin} doLoad={doLoad} />
      </React.Fragment>
    );
  }
}

export default MainPage;
